export default __webpack_public_path__ + "locales/el-GR/InfoPanel.json?hash=20d517633eeb2cb150f58c3ce0267ce2";